import React from 'react'
import PropTypes from 'prop-types';

const  YesOrNo = ({ name, value, onChange }) => {

  const handleChange = e => {

    onChange({
     target: {
       name,
       value: +e.target.value 
     } 
    })
  }

  return (
    <div className="flex space-x-2">
      <div className="flex space-x-2 items-center">
        <input onChange={handleChange} checked={value === 1}  value={1} name={`${name}-yes-or-no`} className="w-5" type="radio" /><span>Yes</span>
      </div>
      <div className="flex space-x-2 items-center">
        <input onChange={handleChange} checked={value === 0} value={0} name={`${name}-yes-or-no`} className="w-5" type="radio" /><span>No</span>
      </div>
    </div>
  )
}

YesOrNo.defaultProps = {
  value: 0,
  onChange: () => {}
}

YesOrNo.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
  onChange: PropTypes.instanceOf(Function)
}

export default YesOrNo
